import { createSlice } from '@reduxjs/toolkit';

export interface ILoader {
  loader: boolean;
}

const initialState: ILoader = {
  loader: false,
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});

export const { setLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
